import React, { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { Grow } from "@material-ui/core";
import SuperAdminSidebar from "./SuperAdminSidebar";
import SuperAdminFooter from "./SuperAdminFooter";
import OverviewTab from "./OverviewTab";
import SubscriptionTab from "./SubscriptionTab";
import SuperAdminUsersTab from "./SuperAdminUsersTab";
import GlobalSettingsTab from "./GlobalSettingsTab";
import SupportContactTab from "./SupportContactTab";
import ProgramLogs from "../ProgramLogs/ProgramLogs";
import styles from "./SuperAdminLayout.module.css";

const PANELS = {
  overview: OverviewTab,
  users: SuperAdminUsersTab,
  subscription: SubscriptionTab,
  support: SupportContactTab,
  settings: GlobalSettingsTab,
  activityLogs: ProgramLogs,
};

// Real, readable URLs per section (was: everything lived at the single
// /Subscribers route with an internal-only tab state) - each section is now
// bookmarkable/shareable/back-button-able on its own.
const PATHS = {
  overview: "/superadmin",
  users: "/superadmin/users",
  subscription: "/superadmin/subscription",
  support: "/superadmin/support",
  settings: "/superadmin/settings",
  activityLogs: "/superadmin/activity-logs",
};

const keyForPath = (pathname) =>
  Object.keys(PATHS).find((key) => PATHS[key] === pathname) || "overview";

const Subscription = () => {
  const history = useHistory();
  const location = useLocation();
  const active = keyForPath(location.pathname);

  // The store-admin body.has-sidebar padding (index.css) reserves space for
  // ITS OWN fixed header/footer - without cancelling it here, that stacks on
  // top of this shell's own margin/footer clearance and leaves a permanent
  // stray scrollbar even on a short page.
  useEffect(() => {
    document.body.classList.add("superadmin-shell");
    return () => document.body.classList.remove("superadmin-shell");
  }, []);

  const goTo = (key) => history.push(PATHS[key] || PATHS.overview);

  return (
    <div className={styles.shell}>
      <SuperAdminSidebar active={active} onSelect={goTo} />
      <div className={styles.content}>
        <div className={styles.contentInner}>
          {Object.entries(PANELS).map(([key, Panel]) => (
            <Grow in={active === key} timeout={220} unmountOnExit mountOnEnter key={key}>
              <div>{active === key && (key === "overview" ? <Panel onNavigate={goTo} /> : <Panel />)}</div>
            </Grow>
          ))}
        </div>
      </div>
      <SuperAdminFooter />
    </div>
  );
};

export default Subscription;
